import { render, staticRenderFns } from "./StatusVencedorEvento.vue?vue&type=template&id=59d083e6&scoped=true"
import script from "./StatusVencedorEvento.vue?vue&type=script&lang=js"
export * from "./StatusVencedorEvento.vue?vue&type=script&lang=js"
import style0 from "./StatusVencedorEvento.vue?vue&type=style&index=0&id=59d083e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d083e6",
  null
  
)

export default component.exports